import { render } from "./B2bFilterButtonUsuarios.vue?vue&type=template&id=2b714a52&scoped=true&lang=pug"
import script from "./B2bFilterButtonUsuarios.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonUsuarios.vue?vue&type=script&lang=js"

import "./B2bFilterButtonUsuarios.vue?vue&type=style&index=0&id=2b714a52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b714a52"]])

export default __exports__